import { useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
import {
  PRODUCT_SEARCH,
  GET_PRODUCT_FILTERS_BY_SEARCH,
} from "../SearchPage/searchPage.gql";

export const useAutocomplete = (props) => {
  const { valid, visible, isSubmitted, searchText } = props;

  const [runSearch, productResult] = useLazyQuery(PRODUCT_SEARCH, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
  });

  const [getProductFiltersBySearch, { data: filtersData }] = useLazyQuery(
    GET_PRODUCT_FILTERS_BY_SEARCH,
    {
      fetchPolicy: "cache-and-network",
      nextFetchPolicy: "cache-first",
    }
  );

  useEffect(() => {
    let getProductsDebounce;
    if (valid && searchText.length > 2 && visible) {
      getProductsDebounce = setTimeout(() => {
        runSearch({
          variables: {
            currentPage: 1,
            inputText: searchText,
            pageSize: 12,
            filters: {},
            sort: { relevance: "DESC" },
          },
        });
        getProductFiltersBySearch({
          variables: {
            search: searchText,
            filters: {},
          },
        });
      }, 500);
    }
    return () => clearTimeout(getProductsDebounce);
  }, [searchText]);

  const { data, error, loading } = productResult;

  const products = data && data.products;
  const filters =
    filtersData && filtersData.products && filtersData.products.aggregations;
  const hasResult = products && products.items;
  const resultCount = products && products.total_count;
  const displayResult =
    valid && searchText && searchText.length > 2 && hasResult;
  const invalidCharacterLength = searchText && searchText.length < 3;
  const invalidCharacters = searchText && !valid;
  let messageType = "";

  if (invalidCharacters) {
    messageType = "INVALID_CHARACTERS";
  } else if (invalidCharacterLength) {
    messageType = "INVALID_CHARACTER_LENGTH";
  } else if (error) {
    messageType = "ERROR";
  } else if (loading) {
    messageType = "LOADING";
  } else if (!displayResult) {
    messageType = isSubmitted ? "NO_KEYWORD" : "PROMPT";
  } else if (!resultCount) {
    messageType = "EMPTY_RESULT";
  } else {
    messageType = "RESULT_SUMMARY";
  }

  const MESSAGES = new Map()
    .set("ERROR", "An error occurred while fetching results.")
    .set("LOADING", "Fetching results...")
    .set("PROMPT", "Search for a product")
    .set("NO_KEYWORD", "Please enter a search term.")
    .set("EMPTY_RESULT", "No results were found.")
    .set(
      "INVALID_CHARACTER_LENGTH",
      "Search term must be at least three characters"
    )
    .set(
      "INVALID_CHARACTERS",
      "Only alphanumeric (a-z, 0-9), _ and - characters are allowed."
    );

  const messageTpl = MESSAGES.get(messageType);
  const message =
    typeof messageTpl === "function" ? messageTpl`${resultCount}` : messageTpl;

  return {
    filters,
    displayResult,
    messageType,
    products,
    resultCount,
    message,
  };
};
